let configTable = {
    paging: true,
    info: true,
    searching: true,
    order:{
      column: 0,
      order: 'desc'
    },
    language: {
      search: "Buscar",
      lengthMenu: "Mostrar _MENU_ registros por página",
      info: "Mostrando página _PAGE_ de _PAGES_",
      infoEmpty: "",
      emptyTable: "No hay registros disponibles",
    }
}

export default configTable